import React, { Component } from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
            AppState: null,
        };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error,
            errorInfo,
        });
        // You can also log error messages to an error reporting service here
    }

    handleAppError = e => {
        const inputText = e.target.value;
        this.setState({
            AppState: inputText,
        });
        this.props.onChange(inputText);
    };

    render() {
        if (this.state.errorInfo) {
            console.warn('ERROR BOUNDARY ERROR');
            // console.log(this.props.children);
            // Error path
            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <div style={{ color: 'red' }}>
                        <h5>Error in App class, cannot get state</h5>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </div>
                    <br />
                    <h2>Please contact an administrator.</h2>
                    <h3>Reload the page to restart the game.</h3>
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;
